<template>
    <v-flex sm6 md4 lg4>
    <div class="layout column align-center mb-3">
      <img src="/img/logo.png" alt="Logotipo de Patronato Cultural Vizcaya" width="150" height="150">
    </div>
    <v-card raised>
      <v-toolbar dark color="primary" flat dense>
        <div class="layout column align-center">
          <v-toolbar-title>
            Registro de usuario
          </v-toolbar-title>
        </div>
      </v-toolbar>
      <v-card-text>
        <registro-form @success="success"></registro-form>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    components: {
      'registro-form': require('./RegistroForm').default
    },

    methods: {
      success(data) {
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>
